import { render } from "./fourteenPage.vue?vue&type=template&id=ba2620be&scoped=true"
import script from "./fourteenPage.vue?vue&type=script&lang=js"
export * from "./fourteenPage.vue?vue&type=script&lang=js"

import "./fourteenPage.vue?vue&type=style&index=0&id=ba2620be&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2620be"]])

export default __exports__